import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { $createParagraphNode, $createTextNode, $getRoot } from 'lexical'
import { FC, useEffect } from 'react'

const FocusPlugin: FC = () => {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    const handleFocus = () => {
      editor.update(() => {
        const root = $getRoot()
        if (root.isEmpty()) {
          const paragraph = $createParagraphNode()
          const textNode = $createTextNode('')
          paragraph.append(textNode)
          root.append(paragraph)
          root.select()
        }
      })
    }

    const contentEditableElement = editor.getRootElement()
    if (contentEditableElement) {
      contentEditableElement.addEventListener('focus', handleFocus)
      return () => {
        contentEditableElement.removeEventListener('focus', handleFocus)
      }
    }
  }, [editor])

  return null
}

export default FocusPlugin
